<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="50%">
      <v-card class="mainC">
        <v-card-title class="headline lighten-2"> </v-card-title>

        <v-card-text>
          <div v-if="dialog">
            <v-carousel
              :continuous="false"
              :cycle="false"
              :show-arrows="imgs.length > 1"
              hide-delimiter-background
              delimiter-icon="mdi-minus"
              :hide-delimiters="imgs.length <= 1"
              height="100%"
            >
              <v-carousel-item v-for="(img, index) in imgs" :key="index">
                <img
                  v-if="img.link.includes('.gif')"
                  :src="img.link"
                  style="width: 100%; height: 100%"
                  :alt="img.link"
                />
                <img
                  v-else
                  :src="img.link"
                  style="width: 100%; height: 100%; align: center"
                  :alt="img.link"
                />
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close" class="close">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ModalImage",
  props: {
    imgs: Object,
    dialog: Boolean,
  },
  methods: {
    close() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.absolute {
  position: absolute;
}
.mainC {
  background-color: #211d49;
}
.close {
  text-decoration: none;
  color: #fffffff6;
  margin: 0 15px;
  font-weight: 600;
  font-size: 15px;
}
</style>